import { toast } from 'react-hot-toast';
import { RenderIcon } from 'src/assets/icons';

interface CustomToastProps {
  message: string;
  type: 'success' | 'error';
}

const CustomToast: React.FC<CustomToastProps> = ({ message, type }) => {
  const isSuccess = type === 'success';
  return (
    <div
      className={`flex items-center justify-between  h-[38px] w-[343px] sm:w-[400px] m-auto sm:mr-[0%] md:mr-[0%] lg:mr-[0%] 2xl:mr-[8%]  md:w-[488px]  px-4 py-2 rounded-lg border-l-4 z-[99999999] font-popins ${
        isSuccess
          ? 'bg-green-800 text-green-400 border-green-500'
          : 'bg-[#2A2A2A] text-[#FA4747] border-[#FA4747]'
      }`}
    >
      <span className="text-sm z-[99999999]">{message}</span>
      <button
        onClick={() => toast.dismiss()}
        className="text-[#717171] hover:text-[#717171] z-[99999999]"
      >
        <RenderIcon type='close'  width={20} height={20} />
      </button>
    </div>
  );
};

export default CustomToast;
